var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"swagger-ui"}},[(_vm.loading)?_c('b-row',{staticClass:"mt-5 align-items-center justify-content-center"},[_c('b-spinner')],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }